// Service for Monthly Cuts — Cierre masivo (ASIS-4963 / FE-004)
import { apiClient, API_CONFIG } from '@/api/core';
import type { ApiResponse } from '@/api/shared';
import type { LC_CloseMonthlyCutsIn, LC_CloseMonthlyCutsOut, CloseMonthlyCutsInput } from '../types';


export class MonthlyCutsClosureService {
  // POST /v1/monthlycuts/management/closures
  // Cierra los cortes indicados que pertenecen al holding del usuario y aún están abiertos. Los ya
  // cerrados se reportan en skippedIds y los inexistentes/de otro holding en notFoundIds.
  async close(
    input: CloseMonthlyCutsInput,
    signal?: AbortSignal,
  ): Promise<ApiResponse<LC_CloseMonthlyCutsOut>> {
    const body: LC_CloseMonthlyCutsIn = { monthlyCutIds: input.monthlyCutIds };
    return apiClient.post<LC_CloseMonthlyCutsOut>(
      API_CONFIG.ENDPOINTS.MONTHLY_CUTS_CLOSURES,
      body,
      { signal },
    );
  }
}

export const monthlyCutsClosureService = new MonthlyCutsClosureService();
